export default "__VITE_ASSET__CO5f06$u__"